import { createNullableProvideInject } from '@collector/shared-ui'

import { PlayersConfig } from '../configuration'

export const [providePlayersConfig, injectPlayersConfig] =
  createNullableProvideInject<PlayersConfig>('playersConfig')
